const initCaseToc = () => {
  const tocCard = document.querySelector(".dex-fyio-toc-card") as HTMLElement | null;
  const ctaCard = document.querySelector(".dex-fyio-cta-card") as HTMLElement | null;
  const sideStack = document.querySelector(".dex-case-side-stack") as HTMLElement | null;
  const aside = document.querySelector(".dex-case-intro__col--aside") as HTMLElement | null;
  const tocLinks = document.querySelectorAll<HTMLAnchorElement>(".dex-fyio-toc-link[href^='#']");
  if (!tocCard || !sideStack || !aside || !tocLinks.length) return;
  if (window.innerWidth < 961) return;

  const HEADER_H = 80;
  const TOP_GAP = 24;
  const TOP_OFFSET = HEADER_H + TOP_GAP;

  const wrap = document.createElement("div");
  wrap.className = "dex-case-side-fixed";
  tocCard.parentNode!.insertBefore(wrap, tocCard);
  wrap.appendChild(tocCard);
  if (ctaCard) wrap.appendChild(ctaCard);

  wrap.style.display = "flex";
  wrap.style.flexDirection = "column";
  wrap.style.gap = "40px";

  const placeholder = document.createElement("div");
  placeholder.style.display = "none";
  wrap.parentNode!.insertBefore(placeholder, wrap.nextSibling);

  let mode = "static";

  const update = () => {
    const asideRect = aside!.getBoundingClientRect();
    const wrapH = wrap.offsetHeight;
    const asideTopAbs = asideRect.top + window.scrollY;
    const asideBottomAbs = asideRect.bottom + window.scrollY;

    const metaCard = sideStack!.querySelector(".dex-fyio-meta-card") as HTMLElement | null;
    const metaBottom = metaCard
      ? metaCard.getBoundingClientRect().bottom + window.scrollY + 40
      : asideTopAbs;

    const fixStart = metaBottom - TOP_OFFSET;
    const fixEnd = asideBottomAbs - wrapH - TOP_OFFSET;
    const scrollY = window.scrollY;

    if (scrollY >= fixStart && scrollY < fixEnd) {
      if (mode !== "fixed") {
        mode = "fixed";
        const asideW = aside!.offsetWidth;
        placeholder.style.display = "block";
        placeholder.style.height = wrapH + "px";
        wrap.style.position = "fixed";
        wrap.style.top = TOP_OFFSET + "px";
        wrap.style.width = asideW + "px";
        wrap.style.zIndex = "10";
      }
    } else if (scrollY >= fixEnd) {
      if (mode !== "bottom") {
        mode = "bottom";
        placeholder.style.display = "block";
        placeholder.style.height = wrapH + "px";
        wrap.style.position = "absolute";
        wrap.style.top = (asideBottomAbs - asideTopAbs - wrapH) + "px";
        wrap.style.width = aside!.offsetWidth + "px";
        wrap.style.zIndex = "10";
        aside!.style.position = "relative";
      }
    } else {
      if (mode !== "static") {
        mode = "static";
        placeholder.style.display = "none";
        wrap.style.position = "";
        wrap.style.top = "";
        wrap.style.width = "";
        wrap.style.zIndex = "";
      }
    }
  };

  const sections: { el: HTMLElement; link: HTMLAnchorElement }[] = [];
  tocLinks.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;
    const el = document.querySelector(href) as HTMLElement | null;
    if (el) sections.push({ el, link });
  });

  const updateActive = () => {
    if (!sections.length) return;
    let activeIdx = 0;
    for (let i = sections.length - 1; i >= 0; i--) {
      if (sections[i].el.getBoundingClientRect().top <= HEADER_H + 20) {
        activeIdx = i;
        break;
      }
    }
    tocLinks.forEach((link) => link.classList.remove("dex-is-active"));
    sections[activeIdx].link.classList.add("dex-is-active");
  };

  tocLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const href = link.getAttribute("href");
      if (!href) return;
      const target = document.querySelector(href) as HTMLElement | null;
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - HEADER_H;
      window.scrollTo({ top, behavior: "smooth" });
    });
  });

  let raf: number | null = null;
  window.addEventListener("scroll", () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      update();
      updateActive();
      raf = null;
    });
  }, { passive: true });

  window.addEventListener("resize", () => {
    if (window.innerWidth < 961) {
      mode = "static";
      wrap.style.position = "";
      wrap.style.top = "";
      wrap.style.width = "";
      placeholder.style.display = "none";
    } else {
      update();
    }
  });

  update();
  updateActive();
};

initCaseToc();
